import PropTypes from 'prop-types';

import { SiteConfigManager } from '@atlas/core';

import { CDN_TYPE_CMS, getCDNUrl } from 'common/utils/utils';

import { setOGTag } from './utils';

const updateMeta = page => {
  const { meta_description, meta_keywords, meta_title, og_description, og_title } = page || {};
  const isMetaTags = SiteConfigManager.getConfig('config.config.seo.meta_tags');
  const defaultMetaTitle = SiteConfigManager.getConfig('config.config.seo.default_meta_title', '');
  const defaultMetaDescription = SiteConfigManager.getConfig(
    'config.config.seo.default_meta_description',
    '',
  );
  const betSharingConfig = SiteConfigManager.getConfig('config.config.bet_sharing', {});
  const isBetSharingAllowed = betSharingConfig?.isActive;
  const metaTitle = meta_title || defaultMetaTitle;
  const metaDescription = meta_description || defaultMetaDescription;
  const metaKeywords =
    meta_keywords || SiteConfigManager.getConfig('config.config.seo.default_meta_keywords', '');
  const ogTitle =
    og_title ||
    SiteConfigManager.getConfig('config.config.seo.og_title') ||
    (isMetaTags ? defaultMetaTitle : '');
  const ogDescription =
    og_description ||
    SiteConfigManager.getConfig('config.config.seo.og_description') ||
    (isMetaTags ? defaultMetaDescription : '');
  const ogSiteName = SiteConfigManager.getConfig('config.config.seo.og_site_name');
  const ogImage = SiteConfigManager.getConfig('global_og_image');
  const facebookLink = betSharingConfig?.method_list?.facebook;

  document.title = metaTitle || window.location.hostname;
  document.head.children.namedItem('title').content = metaTitle;
  document.head.children.namedItem('description').content = metaDescription;
  document.head.children.namedItem('keywords').content = metaKeywords;

  setOGTag('title', ogTitle);
  setOGTag('description', ogDescription);
  setOGTag('site_name', ogSiteName);
  setOGTag('type', 'website');
  setOGTag('url', window.location.href);

  if (ogImage) {
    setOGTag('image', `${getCDNUrl(CDN_TYPE_CMS)}/${ogImage}`);
  }

  if (facebookLink) {
    if (isBetSharingAllowed) {
      setOGTag('description', facebookLink.message);
    }

    if (facebookLink.image && isBetSharingAllowed) {
      setOGTag('image', facebookLink.image);
    }
  }
};

updateMeta.propTypes = {
  page: PropTypes.object,
};

export default updateMeta;
